import { useQuery } from '@apollo/client'
import {
    CandidateFilterCategory,
    SearchIndexField,
} from '__generated__/graphql'
import { useState } from 'react'
import { FilterWrapper } from 'recruiter/components/FilterWrapper'
import { useRosterSearchFilter } from 'recruiter/hooks'
import { GetOfficeLocationsById } from 'shared/components/OfficeLocationsAutocomplete/OfficeLocationsAutocomplete.gql'
import OfficeLocationsAutocompleteMultiple from 'shared/components/OfficeLocationsAutocomplete/OfficeLocationsAutocompleteMultiple'
import { OfficeLocationsAutocompleteProps } from 'shared/components/OfficeLocationsAutocomplete/OfficeLocationsAutocompleteProps'

export function RosterLocationFilter() {
    const { value, setValue } = useRosterSearchFilter(
        SearchIndexField.RosterGeoLocations
    )
    const [open, setOpen] = useState(false)

    const officeLocationIds = value?.value?.stringArray ?? []

    const { data, loading } = useQuery(GetOfficeLocationsById, {
        variables: { ids: officeLocationIds },
    })

    const handleOfficeLocationChange: OfficeLocationsAutocompleteProps<true>['onChange'] =
        (_, newValues) => {
            if (newValues.length === 0) {
                setValue(null)
                return
            }

            setValue({
                category: CandidateFilterCategory.All,
                value: { stringArray: newValues.map(({ id }) => id) },
            })
        }

    return (
        <FilterWrapper label="Location">
            <OfficeLocationsAutocompleteMultiple
                ChipProps={{ size: 'small' }}
                loading={loading}
                onChange={handleOfficeLocationChange}
                getOptionLabel={({ value }) => value}
                placeholder="Search locations..."
                value={data?.officeLocationsById || []}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={(_, reason) => {
                    if (reason === 'blur') {
                        setOpen(false)
                    }
                }}
            />
        </FilterWrapper>
    )
}
